import CloseIcon from "@mui/icons-material/Close";
import Person from "@mui/icons-material/AccountCircle";
import { useTheme } from "../../context/ThemeContext";
import { Camera } from "lucide-react";

const ProfileImageModal = ({
  isOpen,
  onClose,
  profileImage,
  onImageUpload,
  uploadingImage,
}) => {
  const { theme } = useTheme();

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm transition-opacity duration-300"
      onClick={onClose}
    >
      <div
        className={`relative rounded-3xl shadow-2xl p-8 border animate-fade-in ${
          theme === "dark"
            ? "bg-[#0f1115] border-gray-700"
            : "bg-[#FAFBFC] border-gray-300"
        }`}
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: "400px", width: "90%" }}
      >
        {/* Close button */}
        <button
          className={`absolute top-4 right-4 transition rounded-full p-1 ${
            theme === "dark"
              ? "text-gray-400 hover:text-white hover:bg-gray-700"
              : "text-gray-500 hover:text-black hover:bg-gray-200"
          }`}
          onClick={onClose}
          aria-label="Close modal"
        >
          <CloseIcon fontSize="small" />
        </button>

        {/* Profile Image Section */}
        <div className="flex flex-col items-center">
          <div className="relative">
            <div
              className={`w-32 h-32 rounded-full overflow-hidden flex items-center justify-center border-4 ${
                theme === "dark"
                  ? "bg-slate-800 border-slate-700"
                  : "bg-slate-200 border-slate-300"
              }`}
            >
              {profileImage ? (
                <img
                  src={profileImage}
                  alt="Profile"
                  className="w-full h-full object-cover"
                />
              ) : (
                <Person
                  style={{ fontSize: 64 }}
                  className={
                    theme === "dark" ? "text-gray-500" : "text-gray-400"
                  }
                />
              )}
            </div>

            {/* Camera button */}
            <label
              htmlFor="profile-image-modal"
              className="absolute bottom-0 right-0 bg-orange-500 text-white p-2.5 rounded-full cursor-pointer hover:bg-orange-400 transition shadow-lg"
              style={{ cursor: uploadingImage ? "wait" : "pointer" }}
            >
              <Camera
                style={{ fontSize: 24 }}
                className={
                  theme === "dark" ? "text-gray-800" : "text-black-100"
                }
              />
              <input
                id="profile-image-modal"
                type="file"
                accept="image/*"
                onChange={onImageUpload}
                className="hidden"
                disabled={uploadingImage}
              />
            </label>
          </div>

          {/* Title */}
          <h3
            className={`text-lg font-semibold mt-4 ${
              theme === "dark" ? "text-white" : "text-gray-800"
            }`}
          >
            Profile Picture
          </h3>
          <p
            className={`text-sm mt-1 text-center ${
              theme === "dark" ? "text-gray-400" : "text-gray-600"
            }`}
          >
            Click the camera icon to upload a new photo
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfileImageModal;
